import { render } from "./FarmItem.vue?vue&type=template&id=4895d872"
import script from "./FarmItem.vue?vue&type=script&lang=js"
export * from "./FarmItem.vue?vue&type=script&lang=js"

import "./FarmItem.vue?vue&type=style&index=0&id=4895d872&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__